<form [formGroup]="signUpProfileForm" class="space-y-8 md:space-y-8 mt-4" action="#">
  <!-- Gender Radio Group -->
  <div class="w-full flex items-end">
    <nrc-input-radio
      class="h-full"
      [formControl]="signUpProfileForm.controls.gender"
      [name]="'signup-profile-gender'"
      [id]="'signup-profile-gender'"
      [options]="genders"
    />

    @if (signUpProfileForm.controls.gender.value === 'DIVERS') {
      <nrc-input-select
        class="grow h-[52px] ml-4"
        [formControl]="signUpProfileForm.controls.pronoun"
        [name]="'signup-profile-gender-pronoun'"
        [id]="'signup-profile-gender-pronoun'"
        [label]="'Pronoun'"
        [options]="[{ value: 'He/Him'}, { value: 'She/Her' }]"
        [labelProperty]="'value'"
        [valueProperty]="'value'"
        [searchEnabled]="false"
      />
    }
  </div>

  <div class="w-full grid gap-8 grid-cols-1 md:grid-cols-2">
    <nrc-input-text
      [formControl]="signUpProfileForm.controls.firstName"
      [type]="'text'"
      [name]="'signup-profile-firstname'"
      [id]="'signup-profile-firstname'"
      [label]="'Firstname'"
      [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
    />

    <nrc-input-text
      [formControl]="signUpProfileForm.controls.lastName"
      [type]="'text'"
      [name]="'signup-profile-lastname'"
      [id]="'signup-profile-lastname'"
      [label]="'Lastname'"
      [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
    />

    <nrc-input-text
      [formControl]="signUpProfileForm.controls.company"
      [type]="'text'"
      [name]="'signup-profile-company'"
      [id]="'signup-profile-company'"
      [label]="'Company'"
      [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
    />

    <nrc-input-select
      [formControl]="signUpProfileForm.controls.purpose"
      [name]="'signup-profile-purpose'"
      [id]="'signup-profile-purpose'"
      [label]="'For what do you use NRC?'"
      [options]="[
        { value: 'Virtual Events' },
        { value: 'Training & Education' },
        { value: 'Client Presentations' },
        { value: 'Internal Communication' },
        { value: 'Other' }
      ]"
      [labelProperty]="'value'"
      [valueProperty]="'value'"
      [searchEnabled]="false"
    />
  </div>

  <!-- Country/Region dropdown -->
  <div class="w-full flex flex-wrap justify-start">
    <span class="inline-block text-sm text-[#adadad] md:text-gray-500 align-middle pt-[2.5px] mr-2">Country/Region&nbsp;</span>

    <nrc-input-select
      class="h-full translate-y-[2px]"
      [formControl]="signUpProfileForm.controls.country"
      [name]="'signup-profile-country'"
      [id]="'signup-profile-country'"
      [options]="countries"
      [labelProperty]="'name'"
      [valueProperty]="'code'"
      [isTransparent]="true"
      [fitContent]="true"
      [searchEnabled]="false"
    />
  </div>
</form>

<p class="mt-8 mb-4 inline-block text-xs text-gray-500 align-middle">
  By signing up, I agree that I have read and accepted the <a href="#" target="_blank" rel="noopener">Terms of Use</a> and <a href="#" target="_blank" rel="noopener">Privacy Policy</a>.
</p>

<div class="mt-4 flex justify-between">
  <nrc-button
    class="min-w-10 h-10 relative"
    [icon]="'arrow-back'"
    [role]="actionRole.SECONDARY"
    [label]="'Go back'"
    (clickEvent)="back()"
  />

  <nrc-button
    class="h-10 relative"
    [label]="'Done'"
    [disabled]="signUpProfileForm.invalid"
    (clickEvent)="done()"
  />
</div>
